import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TimeService} from "../../../../core/services/time.service";

@Component({
  selector: 'app-evidence-sidebar',
  templateUrl: './evidence-sidebar.component.html',
  styleUrls: ['./evidence-sidebar.component.scss', '../../../../../assets/audit/audit.scss']
})
export class EvidenceSidebarComponent {
    @Input() evidence: any = null;
    @Input() receiver: any = null;
    @Input() document: any = null;
    @Output() close = new EventEmitter();


    constructor(
        public timeService: TimeService
    ) {

    }

    hasCustomEntries() {
        return this.evidence && Array.isArray(this.evidence.custom_entries) && this.evidence.custom_entries.length > 0;
    }

    customTitle() {
        if (this.hasCustomEntries() && typeof this.evidence.custom_entries[0]['custom_evidence_name'] === 'string') {
            return this.evidence.custom_entries[0]['custom_evidence_name'];
        }
        return '';
    }

}
